import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _answer = { score: 'google.protobuf.DoubleValue' };
var _createQuizSubmissionBySubmitterRequest = {
    submission: '_quizSubmission',
};
var _createQuizSubmissionBySubmitterResponse = {
    submission: '_quizSubmission',
};
var _createQuizSubmissionRequest = { submission: '_quizSubmission' };
var _createQuizSubmissionResponse = { submission: '_quizSubmission' };
var _deleteQuizSubmissionRequest = {};
var _deleteQuizSubmissionResponse = { submission: '_quizSubmission' };
var _getQuizSubmissionRequest = {};
var _getQuizSubmissionResponse = {
    submission: '_quizSubmission',
    quizSubmission: '_quizSubmission',
};
var _quizSubmission = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    answers: 'Map#_answer',
};
function resolveWixAchievementsQuizzesV1QuizSubmissionsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/quiz-submissions-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/quiz-submissions-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/quiz-submissions-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/quiz-submissions-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates quiz submission */
export function createQuizSubmission(payload) {
    var _a = serializer(_createQuizSubmissionRequest, { _answer: _answer, _quizSubmission: _quizSubmission }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createQuizSubmissionResponse, {
        _answer: _answer,
        _quizSubmission: _quizSubmission,
    }).fromJSON;
    function __createQuizSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.quizzes.v1.quiz_submission',
            method: 'POST',
            methodFqn: 'wix.achievements.quizzes.v1.QuizSubmissionsService.CreateQuizSubmission',
            url: resolveWixAchievementsQuizzesV1QuizSubmissionsServiceUrl({
                protoPath: '/v1/submissions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createQuizSubmission.fromReq = fromReq;
    __createQuizSubmission.__isAmbassador = true;
    return __createQuizSubmission;
}
/** Creates quiz submission with submitter identity taken from request body instead of headers. It's internal endpoint used for data migrations */
export function createQuizSubmissionBySubmitter(payload) {
    var _a = serializer(_createQuizSubmissionBySubmitterRequest, { _answer: _answer, _quizSubmission: _quizSubmission }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createQuizSubmissionBySubmitterResponse, { _answer: _answer, _quizSubmission: _quizSubmission }).fromJSON;
    function __createQuizSubmissionBySubmitter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.quizzes.v1.quiz_submission',
            method: 'POST',
            methodFqn: 'wix.achievements.quizzes.v1.QuizSubmissionsService.CreateQuizSubmissionBySubmitter',
            url: resolveWixAchievementsQuizzesV1QuizSubmissionsServiceUrl({
                protoPath: '/v1/submissions/by-submitter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createQuizSubmissionBySubmitter.fromReq = fromReq;
    __createQuizSubmissionBySubmitter.__isAmbassador = true;
    return __createQuizSubmissionBySubmitter;
}
/** Gets quiz submission by ID */
export function getQuizSubmission(payload) {
    var _a = serializer(_getQuizSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getQuizSubmissionResponse, {
        _answer: _answer,
        _quizSubmission: _quizSubmission,
    }).fromJSON;
    function __getQuizSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.quizzes.v1.quiz_submission',
            method: 'GET',
            methodFqn: 'wix.achievements.quizzes.v1.QuizSubmissionsService.GetQuizSubmission',
            url: resolveWixAchievementsQuizzesV1QuizSubmissionsServiceUrl({
                protoPath: '/v1/submissions/{submissionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getQuizSubmission.fromReq = fromReq;
    __getQuizSubmission.__isAmbassador = true;
    return __getQuizSubmission;
}
/** Deletes quiz submission */
export function deleteQuizSubmission(payload) {
    var _a = serializer(_deleteQuizSubmissionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteQuizSubmissionResponse, {
        _answer: _answer,
        _quizSubmission: _quizSubmission,
    }).fromJSON;
    function __deleteQuizSubmission(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.achievements.quizzes.v1.quiz_submission',
            method: 'DELETE',
            methodFqn: 'wix.achievements.quizzes.v1.QuizSubmissionsService.DeleteQuizSubmission',
            url: resolveWixAchievementsQuizzesV1QuizSubmissionsServiceUrl({
                protoPath: '/v1/submissions/{submissionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteQuizSubmission.fromReq = fromReq;
    __deleteQuizSubmission.__isAmbassador = true;
    return __deleteQuizSubmission;
}
//# sourceMappingURL=http.impl.js.map